import React, { useState } from 'react';
import { registerUser } from '../../services/authService';
import { Form, Input, Button, Typography, Card } from 'antd';

const { Title, Text } = Typography;

const Register = () => {
  const [formState, setFormState] = useState({ name: '', email: '', password: '' });
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  const handleRegister = async () => {
    try {
      await registerUser(formState);
      setMessage('Registration successful. You can now log in.');
    } catch (err) {
      setMessage(err.response?.data?.message || 'Registration failed');
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 100 }}>
      <Card style={{ width: 400 }}>
        <Title level={3} style={{ textAlign: 'center' }}>Register</Title>
        <Form layout="vertical" onFinish={handleRegister}>
          <Form.Item label="Name" name="name" rules={[{ required: true, message: 'Please enter your name' }]}>
            <Input name="name" onChange={handleChange} />
          </Form.Item>
          <Form.Item label="Email" name="email" rules={[{ required: true, message: 'Please enter your email' }]}>
            <Input name="email" onChange={handleChange} />
          </Form.Item>
          <Form.Item label="Password" name="password" rules={[{ required: true, message: 'Please enter your password' }]}>
            <Input.Password name="password" onChange={handleChange} />
          </Form.Item>
          {message && <Text type={message.includes('successful') ? 'success' : 'danger'}>{message}</Text>}
          <Form.Item style={{ marginTop: 16 }}>
            <Button type="primary" htmlType="submit" block>
              Register
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Register;
